import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientSidenav from '../components/ClientSidenav';
import './Planos.css';

const PLANS = [
  {
    name: 'Café Pingado',
    icon: '☕',
    type: 'free',
    colorBar: 'linear-gradient(90deg, #a67c52, #7a5230)',
    iconBg: 'rgba(166, 124, 82, 0.14)',
    features: [
      'Acesso aos cursos gratuitos',
      'Certificado digital de conclusão',
      'Comunidade de alunos',
      'Suporte por e-mail',
    ],
    popular: false,
  },
  {
    name: 'Café Longo',
    icon: '🫘',
    type: 'paid',
    price: '129',
    cents: '00',
    colorBar: 'linear-gradient(90deg, #c4722a, #8b3a14)',
    iconBg: 'rgba(196, 114, 42, 0.14)',
    features: [
      'Tudo do Café Tradicional',
      'Biblioteca completa de cursos',
      'Certificado digital premium',
      'Suporte prioritário',
      'Novos cursos toda semana',
    ],
    popular: false,
  },
  {
    name: 'Expresso',
    icon: '⚡',
    type: 'paid',
    price: '189',
    cents: '00',
    colorBar: 'linear-gradient(90deg, #8b3a14, #5c2208)',
    iconBg: 'rgba(139, 58, 20, 0.16)',
    features: [
      'Tudo do Café Forte',
      'Plano de estudos personalizado',
      'Projetos práticos com feedback',
      'Suporte via chat em horário comercial',
      'Comunidade exclusiva',
      'Downloads e materiais complementares',
    ],
    popular: true,
  },
  {
    name: 'Expresso Doppio',
    icon: '🏆',
    type: 'paid',
    price: '259',
    cents: '00',
    colorBar: 'linear-gradient(90deg, #d4a060, #c4722a, #8b3a14)',
    iconBg: 'rgba(212, 160, 96, 0.14)',
    features: [
      'Tudo do Expresso',
      'Acesso antecipado a novos cursos',
      'Sessões ao vivo mensais com Q&A',
      'Comunidade VIP com acesso ao instrutor',
      'Suporte prioritário 24/7',
      'Trilhas de certificação Cloud & DevOps',
      'Projetos reais com revisão de código',
    ],
    popular: false,
  },
  {
    name: 'Mentoria Especializada',
    icon: '🎯',
    type: 'waitlist',
    colorBar: 'linear-gradient(90deg, #d4a060, #c4944a, #d4a060)',
    iconBg: 'rgba(212, 160, 96, 0.14)',
    features: [
      'Acompanhamento individual e em grupo',
      'Turmas com datas definidas e vagas limitadas',
      'Mentores especialistas sênior em Cloud/DevOps',
      'Plano de carreira personalizado',
      'Projetos reais com feedback detalhado',
      'Certificado especial de mentoria',
      'Acesso vitalício ao conteúdo da turma',
    ],
    popular: false,
  },
];

function Planos() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('user_data');
    if (userData) setUser(JSON.parse(userData));
  }, []);

  const handleButtonClick = (plan) => {
    if (plan.type === 'free') return;
    if (plan.type === 'waitlist') {
      alert('Obrigado pelo interesse! Entraremos em contato quando novas turmas estiverem abertas.');
      return;
    }
    if (!user) { navigate('/treinamentos'); return; }
    alert(`Plano ${plan.name} selecionado! Implementação de pagamento em breve.`);
  };

  const getButtonClass = (plan) => {
    if (plan.type === 'free')     return 'plan-btn plan-btn-free';
    if (plan.type === 'waitlist') return 'plan-btn plan-btn-waitlist';
    if (plan.popular)             return 'plan-btn plan-btn-primary';
    return 'plan-btn plan-btn-outline';
  };

  const getButtonLabel = (plan) => {
    if (plan.type === 'free')     return 'Incluído no cadastro';
    if (plan.type === 'waitlist') return 'Entrar na lista de espera';
    return `Assinar ${plan.name}`;
  };

  return (
    <div className="planos-page">
      <ClientSidenav />

      {/* Hero */}
      <section className="planos-hero">
        <div className="planos-orbs">
          <div className="planos-orb planos-orb-1"/>
          <div className="planos-orb planos-orb-2"/>
        </div>
        <div className="planos-hero-inner">
          <div className="planos-badge">Planos & Preços</div>
          <h1 className="planos-title">Escolha o Plano Ideal para Você</h1>
          <p className="planos-subtitle">
            Do acesso gratuito à mentoria especializada — evolua no seu ritmo
            com os melhores cursos de Cloud e DevOps.
          </p>
        </div>
      </section>

      {/* Plans */}
      <div className="planos-grid">
        {PLANS.map((plan) => (
          <div
            key={plan.name}
            className={[
              'plan-card',
              plan.popular  ? 'popular'  : '',
              plan.type === 'free'     ? 'free'     : '',
              plan.type === 'waitlist' ? 'mentoria' : '',
            ].filter(Boolean).join(' ')}
          >
            {plan.popular && <div className="plan-popular-badge">Mais Popular</div>}
            {plan.type === 'waitlist' && <div className="plan-waitlist-badge">Vagas Limitadas</div>}

            <div className="plan-header">
              <div className="plan-color-bar" style={{ background: plan.colorBar }}/>
              <div className="plan-icon" style={{ background: plan.iconBg }}>{plan.icon}</div>
              <div className="plan-name">{plan.name}</div>

              {plan.type === 'free' && (
                <div className="plan-price-free">Grátis</div>
              )}
              {plan.type === 'paid' && (
                <div className="plan-price-row">
                  <span className="plan-currency">R$</span>
                  <span className="plan-price-value">{plan.price}</span>
                  <span className="plan-period">,{plan.cents}/mês</span>
                </div>
              )}
              {plan.type === 'waitlist' && (
                <div className="plan-price-waitlist">Consulte as turmas</div>
              )}
            </div>

            <div className="plan-body">
              <div className="plan-divider"/>
              <ul className="plan-features">
                {plan.features.map((f, i) => (
                  <li key={i} className="plan-feature">
                    <span className="plan-check">
                      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="2 6 5 9 10 3"/>
                      </svg>
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                className={getButtonClass(plan)}
                onClick={() => handleButtonClick(plan)}
                disabled={plan.type === 'free'}
              >
                {getButtonLabel(plan)}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ */}
      <section className="planos-faq">
        <h2 className="faq-title">Perguntas Frequentes</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>Posso cancelar a qualquer momento?</h3>
            <p>Sim! Você pode cancelar sua assinatura quando quiser, sem multas ou taxas adicionais.</p>
          </div>
          <div className="faq-item">
            <h3>Os certificados são reconhecidos?</h3>
            <p>Sim, nossos certificados são digitais e podem ser compartilhados no LinkedIn e portfólios.</p>
          </div>
          <div className="faq-item">
            <h3>Posso mudar de plano depois?</h3>
            <p>Claro! Você pode fazer upgrade ou downgrade do seu plano a qualquer momento.</p>
          </div>
          <div className="faq-item">
            <h3>Há garantia de reembolso?</h3>
            <p>Oferecemos 7 dias de garantia. Se não gostar, devolvemos 100% do seu dinheiro.</p>
          </div>
        </div>
      </section>

      <footer className="planos-footer">
        © 2026 Cloud Cafe & DevOps. Todos os direitos reservados.
      </footer>
    </div>
  );
}

export default Planos;
